export default __webpack_public_path__ + "static/media/map-pin-empty.feb09996.svg";